import React from 'react';
import Modal from '../Modal';
import RedDelCliente from './RedDelCliente';
import SituacionRed from './SituacionRed';
import { sd } from './clientesEstilos';

export default function DetalleClienteModal({
  abierto, onCerrar, clienteDetalle, fotos, fotoActiva,
  verFotoCompleta, cerrarFotoActiva,
}) {
  if (!clienteDetalle) return null;
  return (
    <Modal abierto={abierto} onCerrar={onCerrar} titulo={`📄 ${clienteDetalle.nombre}`} ancho="640px">
      {/* Lo técnico va primero: es lo que se necesita cuando el cliente llama porque no
          le sirve el servicio. Las fotos quedan debajo.
          «RedDelCliente» sale al instante con lo que ya venía en la lista; «SituacionRed»
          consulta la señal y a los vecinos del AP, que es la parte lenta. Así se ve algo
          útil de inmediato en vez de una pantalla en blanco esperando. */}
      <RedDelCliente cliente={clienteDetalle} />
      <SituacionRed clienteId={clienteDetalle.id} />

      {/* GPS */}
      {(clienteDetalle.latitud && clienteDetalle.longitud) && (
        <div style={sd.gpsBox}>
          <span style={sd.gpsIcon}>📍</span>
          <div style={{ flex:1 }}>
            <div style={sd.gpsCoordenadas}>{clienteDetalle.latitud}, {clienteDetalle.longitud}</div>
            {clienteDetalle.direccion && <div style={sd.gpsDireccion}>{clienteDetalle.direccion}</div>}
          </div>
          <a href={`https://www.google.com/maps?q=${clienteDetalle.latitud},${clienteDetalle.longitud}`} target="_blank" rel="noopener noreferrer" style={sd.gpsBtn}>
            🗺 Ver mapa
          </a>
        </div>
      )}

      {/* Aquí las fotos SOLO se miran. Subirlas o borrarlas se hace en la ficha del
          cliente (Editar), que es donde se cambian sus datos. Esta pantalla la abre
          cualquiera para ver cómo quedó una instalación, y tener el botón de borrar a un
          clic de la foto es pedir un accidente. */}
      {/* Galería de fotos */}
      {fotos.length === 0 ? (
        <div style={sd.sinFotos}>Sin fotos de instalación registradas</div>
      ) : (
        <div style={sd.galeria}>
          {fotos.map(foto => (
            <div key={foto.id} style={sd.fotoCard} onClick={() => verFotoCompleta(foto)}>
              <div style={sd.fotoNombre}>{foto.nombre}</div>
              <div style={sd.fotoFecha}>{new Date(foto.creado_en).toLocaleDateString('es-CO')}</div>
              <div style={sd.fotoSubidoPor}>👤 {foto.subido_por}</div>
            </div>
          ))}
        </div>
      )}

      {/* Vista foto completa */}
      {fotoActiva && (
        <div style={sd.fotoVisor}>
          <img src={`data:${fotoActiva.mime_type};base64,${fotoActiva.foto_base64}`} alt={fotoActiva.nombre} style={sd.fotoImg} />
          <button style={sd.cerrarFoto} onClick={cerrarFotoActiva}>✕ Cerrar</button>
        </div>
      )}
    </Modal>
  );
}
